export default class InstanceSummary {
  active: number;

  inactive: number;

  activeWithConsumption: number;

  activeWithoutConsumption: number;

  inactiveWithConsumption: number;

  inactiveWithoutConsumption:number;

  unboundInstance: number;

  unboundInstanceWithConsumption: number;

  unboundInstanceWithoutConsumption: number;

  constructor(obj: any = {}) {
    this.active = obj.active || 0;
    this.inactive = obj.inactive || 0;
    this.activeWithConsumption = obj.activeWithConsumption || 0;
    this.activeWithoutConsumption = obj.activeWithoutConsumption || 0;
    this.inactiveWithConsumption = obj.inactiveWithConsumption || 0;
    this.inactiveWithoutConsumption = obj.inactiveWithoutConsumption || 0;
    this.unboundInstance = obj.unboundInstance || 0;
    this.unboundInstanceWithConsumption = obj.unboundInstanceWithConsumption || 0;
    this.unboundInstanceWithoutConsumption = obj.unboundInstanceWithoutConsumption || 0;
  }
}
